import * as constants from '../config/constants.js';
import ElementClassHandler from './element-class-handler.js';
import ClassList from 'classlist';

export default class MDLFormFields {

    mdlFormFill(propertyElem, propertySelector) {
        let formFillElem = document.querySelector(propertySelector),
            classList = new ClassList(formFillElem.parentElement),
            elementClassHandler = new ElementClassHandler;
        if (classList.contains(constants.MDL_TEXTFIELD_FLOATING_LABEL_CLASS)) {
            if (!propertyElem && classList.contains(constants.MDL_DIRTY_CLASS)) {
                elementClassHandler.remove(formFillElem.parentElement, constants.MDL_DIRTY_CLASS);
            } else if (propertyElem && !classList.contains(constants.MDL_DIRTY_CLASS)) {
                elementClassHandler.add(formFillElem.parentElement, constants.MDL_DIRTY_CLASS);
            }
        }
        formFillElem.value = propertyElem;
    }

}
